import { useFormContext } from 'react-hook-form'

import { FormError, SearchSelect } from '@fortem-monorepo/react-ui'
import { FormField, FormItem, FormLabel } from '@fortem-monorepo/react-ui'

export interface WrapperBucketIdFormFieldProps {
  wrapperBuckets?: { label: string; value: number }[]
  loading?: boolean
}

export const WrapperBucketIdFormField: React.FC<WrapperBucketIdFormFieldProps> = ({
  wrapperBuckets,
  loading,
}) => {
  const { control, setValue } = useFormContext<{ wrapper_bucket_id: number | null }>()

  return (
    <FormField
      name="wrapper_bucket_id"
      control={control}
      render={({ field }) => {
        return (
          <FormItem>
            <div className="flex items-center gap-2">
              <FormLabel>Wrapper Bucket</FormLabel>
              <FormError />
            </div>
            <SearchSelect
              placeholder={'Select a Wrapper Bucket'}
              value={field.value?.toString()}
              loading={loading}
              setValue={(val) =>
                setValue('wrapper_bucket_id', val ? parseInt(val) : null, {
                  shouldValidate: true,
                })
              }
              options={wrapperBuckets?.map(({ label, value }) => ({
                label,
                value: value?.toString(),
              }))}
            />
          </FormItem>
        )
      }}
    />
  )
}
